import { render, staticRenderFns } from "./InventoryAnchorCard.vue?vue&type=template&id=79d10d64&"
import script from "./InventoryAnchorCard.vue?vue&type=script&lang=js&"
export * from "./InventoryAnchorCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAnchorCard.vue?vue&type=style&index=0&id=79d10d64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports